export default __webpack_public_path__ + "static/media/book_room-bw.5b7decdb.png";